import React from 'react';
import { ScrollArea } from '../ui/scroll-area';
import WorkOrderTreeItem from './WorkOrderTreeItem';
import { Loader2, ClipboardList } from 'lucide-react';

function ScheduleSidebar({ orders, isLoading, onBatchAssign }) {
  const totalSteps = orders.reduce(
    (sum, order) =>
      sum +
      order.items?.reduce(
        (isum, item) => isum + (item.steps?.filter((s) => !s.is_subcontracted).length || 0),
        0
      ),
    0
  );

  return (
    <div className="w-[340px] flex flex-col border-r border-gray-200 bg-gray-50 shrink-0">
      <div className="px-3 py-2 border-b border-gray-200 bg-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5">
            <ClipboardList className="h-4 w-4 text-gray-600" />
            <span className="text-sm font-semibold text-gray-800">待分配工序</span>
          </div>
          <span className="text-xs text-gray-500">
            {orders.length}个工单 · {totalSteps}个工序
          </span>
        </div>
      </div>

      <ScrollArea className="flex-1 px-2 py-2">
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-5 w-5 animate-spin text-gray-400" />
            <span className="ml-2 text-sm text-gray-500">加载中...</span>
          </div>
        ) : orders.length === 0 ? (
          <div className="text-center py-8 text-sm text-gray-400">
            暂无待分配工序
          </div>
        ) : (
          orders.map((order) => (
            <WorkOrderTreeItem
              key={order.production_order_id}
              order={order}
              onBatchAssign={onBatchAssign}
            />
          ))
        )}
      </ScrollArea>
    </div>
  );
}

export default ScheduleSidebar;
